const actions = {
    async getChangeHistoriesList({ rootGetters }, { params } = {}) {
        return await this.getDataStore(`${rootGetters.API}/united_table_change_histories`, params);
    }
};
export default { actions };
